import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";

const WelcomeConfirmation = () => {
  const [editHero, setEditHero] = useState(false);
  const [heroPosition, setHeroPosition] = useState({ x: 50, y: 80 });

  return (
    <div className="min-h-screen bg-[#F9F7F2] relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover opacity-60"
        style={{
          backgroundImage:
            "url(https://customer-assets.emergentagent.com/job_react-revamp-2/artifacts/mp8zmyja_MESANGE.HEIC)",
          backgroundPosition: `${heroPosition.x}% ${heroPosition.y}%`,
        }}
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#F9F7F2]/60 to-[#F9F7F2]" />

      {/* Petit mode  e9dition pour la photo hero (centrage) */}
      <div className="absolute top-6 right-6 z-20 flex flex-col items-end gap-1">
        <button
          type="button"
          onClick={() => setEditHero(!editHero)}
          className="text-[0.6rem] tracking-[0.18em] uppercase px-3 py-1 rounded-full bg-[#3F2A24]/80 text-[#F3E5CF] shadow-sm hover:bg-[#6E3A1E]"
        >
          {editHero ? "Mode  e9dition photo : ON" : "Mode  e9dition photo : OFF"}
        </button>

        {editHero && (
          <div className="flex flex-col items-end gap-1 bg-[#3F2A24]/85 px-2 py-2 rounded-2xl text-[#F3E5CF] text-[0.6rem]">
            <div className="flex justify-between gap-2 w-full">
              <span className="tracking-[0.15em] uppercase opacity-80">Centrer la photo</span>
            </div>
            <div className="flex items-center justify-between gap-2">
              <div className="flex flex-col gap-1">
                <button
                  type="button"
                  onClick={() =>
                    setHeroPosition((pos) => ({ ...pos, y: Math.max(20, pos.y - 3) }))
                  }
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                   d ↑ Haut
                </button>
                <button
                  type="button"
                  onClick={() => setHeroPosition({ x: 50, y: 50 })}
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                   b • Centre
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setHeroPosition((pos) => ({ ...pos, y: Math.min(80, pos.y + 3) }))
                  }
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                   d ↓ Bas
                </button>
              </div>
              <div className="flex flex-col gap-1">
                <button
                  type="button"
                  onClick={() =>
                    setHeroPosition((pos) => ({ ...pos, x: Math.max(20, pos.x - 3) }))
                  }
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                   d ← Gauche
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setHeroPosition((pos) => ({ ...pos, x: Math.min(80, pos.x + 3) }))
                  }
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                  Droite →
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6">
        <div className="max-w-md w-full animate-fade-in-up bg-[#F9F7F2]/90 rounded-2xl px-6 py-10 shadow-lg">
          <h1 className="font-serif text-2xl text-[#3F2A24] mb-4 text-center">
            Merci pour ta demande 🤍
          </h1>
          <p className="text-[#4B3329] leading-relaxed mb-4 text-center">
            Jeinar va vérifier ton inscription à la retraite<br />
            et t’envoyer ton lien d’accès personnel dans les plus brefs délais.
          </p>
          <p className="text-[#4B3329] leading-relaxed mb-6 text-center">
            Ce lien te permettra d’entrer dans ton espace,<br />
            simplement et en toute sécurité.
          </p>
          <p className="text-sm text-[#8C6A4A] text-center mb-6">
            Tu peux maintenant fermer cette page en confiance.
          </p>

          <div className="text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-[#8C6A4A] hover:text-[#C5A059] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Retour à la page d’accueil</span>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default WelcomeConfirmation;
